import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MainApiService from "../../../../services/mainApi.service";
import {
  OverflowTooltip,
  Table,
  useNotificationContext,
} from "@4uhub/lib4uhub";
import { IListClassifications } from "../../../../models/list-classification";
import { Chip, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { useEffect } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const BANK_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/ListClassification/";
const bankService = new MainApiService<IListClassifications>(BANK_ROUTE);

const translationPath = "page.4uDlist.listClassification.";

const ListClassificationPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  useEffect(() => {
    bankService.list().then((r) => console.log(r));
  }, []);

  const { setMessage } = useNotificationContext();

  const copyTokenHandler = (
    event: React.MouseEvent<HTMLButtonElement> | undefined,
    text: string
  ) => {
    event?.stopPropagation();
    navigator.clipboard.writeText(text);
    setMessage({
      message: t(translationPath + "copied"),
      type: "success",
    });
  };

  const columns: GridColDef<IListClassifications>[] = [
    {
      field: "code",
      headerName: t(translationPath + "code") || "Code",
      maxWidth: 120,
      renderCell: (params) => {
        if (params.value.length === 0 || !params.value) {
          return "-";
        }
        return (
          <Stack width={"100%"} flexDirection={"row"} alignItems={"center"}>
            <Tooltip title={params.value}>
              <Typography
                variant="subtitle2"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {params.value}
              </Typography>
            </Tooltip>
            <Tooltip title={t(translationPath + "copy")}>
              <IconButton
                size="small"
                onClick={(e) => copyTokenHandler(e, params.value)}
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      },
    },
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "description",
      headerName: t(translationPath + "description") || "Description",
      renderCell: ({ row: { description } }) => {
        return description && description.length > 0 ? (
          <OverflowTooltip
            text={description}
            tooltip={description}
            textTransform="none"
            variant="body2"
          />
        ) : (
          "-"
        );
      },
    },
    {
      field: "enable",
      headerName: t(translationPath + "status") || "Status",
      maxWidth: 150,
      renderCell: ({ row: { enable } }) => {
        return (
          <Chip
            label={
              enable
                ? t(translationPath + "active")
                : t(translationPath + "inactive")
            }
            color={enable ? "success" : "error"}
          />
        );
      },
    },
  ];

  const handleRowClick = (params: GridRowParams<IListClassifications>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  const handleAdd = () => {
    navigate("new");
  };

  return (
    <Table<IListClassifications>
      showDefaultMacroFilters={false}
      service={bankService}
      columns={columns}
      title={t(translationPath + "title")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={
        t(translationPath + "search") || "Search for a list classification"
      }
      addButtonLabel={t(translationPath + "add") || "Add List Classification"}
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default ListClassificationPage;
